import styles from './LoadingDots.module.css';

/**
 * A "Loading" label whose trailing dots pulse.
 *
 * The pulse is driven entirely by CSS. A device list mounts one of these per row, so a
 * per-instance timer would cost one React commit per badge per tick purely to swap a text
 * node. All three dots stay in the layout and only change opacity, so the label keeps a
 * constant width and nothing around it reflows while it animates.
 */
export default function LoadingDots({ label = 'Loading', className = '' }) {
  const classNames = [styles.root, className].filter(Boolean).join(' ');

  return (
    <span className={classNames} aria-label={label}>
      <span>{label}</span>
      <span className={styles.dots} aria-hidden="true">
        <span className={styles.dot}>.</span>
        <span className={styles.dot}>.</span>
        <span className={styles.dot}>.</span>
      </span>
    </span>
  );
}
